(() => {
  const cfg = window.themeConfig || {};
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  if (cfg.cardTilt && window.matchMedia('(hover: hover) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let pending = null, raf = 0;
    document.addEventListener('pointermove', (event) => {
      const card = event.target.closest('[data-tilt-card]');
      if (!card) return;
      pending = { card, x: event.clientX, y: event.clientY };
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0; if (!pending) return;
        const { card, x, y } = pending; pending = null;
        const media = $('.product-card__media', card); if (!media) return;
        const rect = media.getBoundingClientRect();
        const px = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
        const py = Math.max(0, Math.min(1, (y - rect.top) / rect.height));
        card.style.setProperty('--tilt-x', `${(0.5 - py) * cfg.cardTilt}deg`);
        card.style.setProperty('--tilt-y', `${(px - 0.5) * cfg.cardTilt}deg`);
        card.style.setProperty('--glow-x', `${px * 100}%`); card.style.setProperty('--glow-y', `${py * 100}%`);
        card.classList.add('is-pointer-active');
      });
    }, { passive: true });
    document.addEventListener('pointerout', (event) => {
      const card = event.target.closest('[data-tilt-card]');
      if (!card || card.contains(event.relatedTarget)) return;
      card.style.setProperty('--tilt-x', '0deg'); card.style.setProperty('--tilt-y', '0deg'); card.classList.remove('is-pointer-active');
    });
  }

  function initLuxuryCursor() {
    const precisePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!cfg.customCursor || !precisePointer || reducedMotion) return;
    document.body.insertAdjacentHTML('beforeend', '<div class="luxury-cursor" aria-hidden="true"><span class="luxury-cursor__ring"><span class="luxury-cursor__label"></span></span><span class="luxury-cursor__dot"></span></div>');
    const cursor = $('.luxury-cursor'), ring = $('.luxury-cursor__ring', cursor), dot = $('.luxury-cursor__dot', cursor), label = $('.luxury-cursor__label', cursor);
    let pointerX=-100,pointerY=-100,ringX=-100,ringY=-100,running=false;
    const render=()=>{
      ringX += (pointerX-ringX)*.18; ringY += (pointerY-ringY)*.18;
      ring.style.transform=`translate3d(${ringX}px,${ringY}px,0) translate(-50%,-50%)`;
      if (Math.abs(pointerX-ringX)>.15 || Math.abs(pointerY-ringY)>.15) requestAnimationFrame(render); else running=false;
    };
    document.documentElement.classList.add('has-luxury-cursor');
    document.addEventListener('pointermove',(event)=>{
      pointerX=event.clientX; pointerY=event.clientY;
      dot.style.transform=`translate3d(${pointerX}px,${pointerY}px,0) translate(-50%,-50%)`;
      cursor.classList.add('is-visible');
      if(!running){running=true;requestAnimationFrame(render);}
    },{passive:true});
    document.addEventListener('pointerover',(event)=>{
      const interactive=event.target.closest('a, button, summary, input, select, textarea, [data-cursor-label]');
      const customLabel=event.target.closest('[data-cursor-label]')?.dataset.cursorLabel||'';
      cursor.classList.toggle('is-interactive',Boolean(interactive)); cursor.classList.toggle('has-label',Boolean(customLabel)); label.textContent=customLabel;
    });
    document.addEventListener('pointerout',(event)=>{ if(!event.relatedTarget) cursor.classList.remove('is-visible','is-interactive','has-label'); });
  }

  let revealObserver;
  function initRevealObserver(scope=document){
    const auto=['.hero-split__content > *','.section-heading > *','.section-title-row > *','.editorial-feature__copy','.story-grid > *','.image-accordion > *','.product-details__grid > *','.collection-hero > *','.page-hero > *','.product-feature'].join(',');
    $$(auto,scope).forEach((el)=>{ if(!el.matches('[data-theme-image-frame]')&&!el.querySelector(':scope > [data-theme-image-frame]')) el.classList.add('reveal'); });
    $$('[data-theme-image-frame]',scope).forEach((frame)=>{frame.classList.remove('reveal','reveal--left','reveal--right','reveal--scale','reveal--wipe-left','reveal--wipe-right','is-visible');frame.removeAttribute('data-reveal-ready');frame.style.removeProperty('--reveal-delay');});
    const targets=$$('.reveal:not([data-reveal-ready])',scope);
    targets.forEach((el,index)=>{el.dataset.revealReady='true';const has=[...el.classList].some((n)=>n.startsWith('reveal--'));if(!has){if(el.matches('.product-card,.product-feature,.about-value,.article-card'))el.classList.add('reveal--scale');else if(el.matches('.media,.hero-split__media,.editorial-feature__large,.editorial-feature__small,.story-grid__hero'))el.classList.add(index%2?'reveal--wipe-left':'reveal--wipe-right');else el.classList.add(index%2?'reveal--right':'reveal--left');}const siblings=[...(el.parentElement?.children||[])].filter((s)=>s.classList.contains('reveal'));el.style.setProperty('--reveal-delay',`${Math.min(Math.max(0,siblings.indexOf(el)),5)*85}ms`);});
    if(cfg.designMode||cfg.revealEnabled===false||window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window)){targets.forEach((el)=>el.classList.add('is-visible'));return;}
    if(!revealObserver) revealObserver=new IntersectionObserver((entries)=>entries.forEach((entry)=>{if(!entry.isIntersecting)return;entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}),{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    targets.forEach((el)=>revealObserver.observe(el));
  }

  initLuxuryCursor();
  initRevealObserver();
  document.addEventListener('shopify:section:load',(event)=>initRevealObserver(event.target));
})();
